import styled, { css } from 'styled-components';

import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const SelectWrapper = styled.div`
  min-width: 220px;
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  margin-bottom: 8px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.onSurfaceVariant};
`;

export const MemberCell = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const Avatar = styled.img`
  width: 46px;
  height: 46px;
  border-radius: ${radius.DEFAULT};
  object-fit: cover;
`;

export const MemberName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.onSurface};
  display: block;
`;

export const MemberUsername = styled.span`
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
`;

interface BadgeProps {
  level: number;
}

export const LevelBadge = styled.span<BadgeProps>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: ${radius.full};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  background-color: ${colors.surfaceContainerHighest};
  color: ${colors.onSurfaceVariant};

  ${({ level }) =>
    level >= 2 &&
    css`
      background-color: ${colors.primary}1a;
      color: ${colors.primary};
    `}
`;

interface StatusBadgeProps {
  status: 'active' | 'inactive';
}

const statusColor = {
  active: colors.primary,
  inactive: colors.onSurfaceVariant,
};

export const StatusBadge = styled.span<StatusBadgeProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 4px 12px;
  border-radius: ${radius.full};

  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;

  background-color: ${({ status }) =>
    status === 'inactive'
      ? colors.surfaceContainerHighest
      : `${statusColor[status]}1a`};
  color: ${({ status }) => statusColor[status]};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;

export const RowLink = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${colors.onSurfaceVariant};

  padding: 8px;
  border-radius: ${radius.DEFAULT};

  display: flex;
  align-items: center;

  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.surfaceContainerHighest};
    color: ${colors.onSurface};
  }
`;
